angular.module('impactx.basket').controller('OrderProgressCtrl',  ['$interval', '$mdDialog', 'basketData', 'progressLabel',
    'successFunction', '$scope', 'dataGen', 'TranslationService', OrderProgressCtrl]);

function OrderProgressCtrl($interval, $mdDialog, basketData, progressLabel, successFunction, $scope, dataGen, TranslationService)
{
    $scope.progressLabel = progressLabel;
    $scope.abortLabel = TranslationService.get("abort");
    var self = this;
    var validationOk = false;
    var timeExpired = false;
    $scope.applyCalled = {value: false};
    this.determinateValue = 1;
    dataGen.post($scope, basketData, "/basket/validateorder", null, null, true, true).then(
        function (data)
        {
            if (data.warnings.length > 0)
            {
                basketData.data.basket = data.data.basket;
                self.stopInterval();
                $mdDialog.cancel();
            }
            else
            {
                validationOk = true;
            }
        },
        function (data)
        {
            basketData.data.basket = data.data.basket;
            self.stopInterval();
        });
    this.determinateInterval = $interval(function() {
        if (validationOk && timeExpired)
        {
            self.apply();
        }
        self.determinateValue += 4;
        if (self.determinateValue > 100)
        {
            timeExpired = true;
            self.determinateValue = 1;
        }
    }, 200);

    this.stopInterval = function() {
        if (angular.isDefined(self.determinateInterval)) {
            $interval.cancel(self.determinateInterval);
            self.determinateInterval = undefined;
        }
    };
    this.cancel = function ()
    {
        self.stopInterval();
        $mdDialog.cancel();
    };
    this.apply = function ()
    {
        if (!$scope.applyCalled.value)
        {
            $scope.applyCalled.value = true;
            successFunction(basketData).then(function () {
                self.stopInterval();
                $mdDialog.hide();
            }, self.cancel);
        }
    };

    this.keyDownCheck = function(event) {
        if (!$scope.applyCalled.value && event.keyCode === 27)
        {
            self.stopInterval();
            $mdDialog.cancel();
        }
    };

    angular.element(document).on('keydown', self.keyDownCheck);

    $scope.$on('$destroy', function () {
        angular.element(document).off('keydown', self.keyDownCheck);
    });
}